import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsAPIService {
  constructor(private _http: HttpClient) {}

  getNewCount(): Observable<{ count: number }> {
    return this._http.get<{ count: number }>(`/api/v1/notifications/new`, {
      withCredentials: true,
    });
  }

  checkNew(): Observable<boolean> {
    return this._http
      .head(`/api/v1/notifications`, {
        withCredentials: true,
        observe: 'response',
      })
      .pipe(
        map(() => {
          return true;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }
}
